import axios from "axios";
import {getFileNameFromContentDisposition, hostWithPrefix} from "../../Constructor/common/ApiCommon";
import {toaster} from "evergreen-ui";

export function generateDeviationReport(deviationData, startP, endP) {
    const req = {
        station: deviationData.station,
        checkedDatasourceType: deviationData.checkedDatasourceType,
        checkedEntity: deviationData.checkedStationEntity,
        idealEntity: deviationData.idealStationEntity,
        idealDatasourceType: deviationData.idealDatasourceType,
        code: deviationData.code,
        period: {
            start: startP,
            end: endP
        }
    }


    axios({
        url: 'http://' + hostWithPrefix + '/deviation/report/create', //your url
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        data: JSON.stringify(req),
        responseType: 'blob', // important
    }).then((response) => {
        let filename = getFileNameFromContentDisposition(response.headers['content-disposition'])
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename); //or any other extension
        document.body.appendChild(link);
        link.click();
        toaster.success('Отклонение рассчитано')
    });
}
